import { render, staticRenderFns } from "./student-case-multi.vue?vue&type=template&id=cee52daa"
import script from "./student-case-multi.vue?vue&type=script&lang=js"
export * from "./student-case-multi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports